<template>
  <div class="vg-content">

  </div>
</template>

<script>
import useProjectStore from "@/store/project";
import {client} from "@/libraries/http";

export default {
  name: "VerifyRefer",
  data() {
    return {
      qrCode: "",
    }
  },
  created() {
    this.qrCode = this.$route.query.qrCode;
    this.verify();
  },
  methods: {
    verify() {
      const projectStore = useProjectStore();
      let params = {
        qrCode: this.qrCode,
        projectId: projectStore.projectInfo.projectId,
      };
      client.post("/api/h5/guard/verify", params).then(res => {
        console.log(res);
        if (res.data.passCardType === 'GOODS_IN_OUT') {
          this.$router.replace({path: '/scanVerify/verifyGoodsInOutResult', query: {id: res.data.id}});
        } else {
          this.$router.replace({path: '/scanVerify/verifyResult', query: {id: res.data.id}});
        }
      }).catch(error => {
        console.log(error);
        this.$router.replace({path: '/scanVerify/verifyResult', query: {message: error.response.data?.message}});
      })
    },
  },
}
</script>

<style scoped>
.vg-content {
  /*margin: 15px;*/
  display: flex;
  flex-direction: column;
}

</style>
